import {keyMirror} from 'utils/DBUtils';

export const DynamicsOperator = keyMirror({
  EQUAL: null,
  NOT_EQUAL: null,
  GREATER_THAN: null,
  GREATER_THAN_EQUAL: null,
  LESS_THAN: null,
  LESS_THAN_EQUAL: null
});

// creates a new dynamic content rule object with some fields initialized. this checks the
// length of the supportedDynamicActions list: if only one action is supported, then we
// can set that on create.
export const dynamicContentRuleFactory = supportedDynamicActions => {
  const dynamicContentRule = {
    field: 'resultId',
    operator: DynamicsOperator.EQUAL
  };

  if (supportedDynamicActions.length === 1) {
    dynamicContentRule.action = supportedDynamicActions[0];
  }

  return dynamicContentRule;
};



// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/DynamicContentRules/utils.js